import Component from '../model/Component';
import $ from "jquery";
import GigyaManager from "../business/GigyaManager";
import HttpClient from "../business/HttpClient";
import {Utils} from "../components/unMorsoDiFelicita/Utils";

class SpecialitaCasaFormComponent extends Component {
    constructor(element, parentCtrl) {
        super(element, parentCtrl);

        this.$element = $(element);
        this.key = "CH_1071_MLB_WEB_SPECIALITACASA_NAV_NAV_20250313_20250328";
        this.urlBack = `/login?urlBack=${window.location.pathname}&regSource=1071`;
        this.$form = this.$element.find('form');
        this.uploadInput = document.querySelector("#fotoRicetta");
        this.preview = document.querySelector(".specialitaCasa__form-preview");

        this.init();
    }

    init() {
        this.checkUser();
        this.previewFile();
        this.deleteFile();
        this.triggerCheckImg();

        this.$element.find('form .submit').on('click',()=> {
            this.submitForm();
        });
    }

    triggerCheckImg() {
        document.addEventListener('click', (e)=> {
            if(e.target.classList.contains('specialitaCasa__form-products-image')) {

                e.target.previousElementSibling.click();

            }
        });
    }

    checkUser() {
        $('#overlayer').show();
        GigyaManager.getLoggedUser().then((user) => {

        }, () => {
            window.location.href = this.urlBack;
        });
    }

    previewFile() {
        document.querySelector("#fotoRicetta").addEventListener("change", () => {this.updateImageDisplay()});

        document.querySelector("#fotoRicetta").addEventListener('cancel', () => {
            if (document.querySelectorAll(".specialitaCasa__form-preview-file img").length > 0) {
                this.fakeFile();
            }
        });
    }

    updateImageDisplay() {
        const fileTypes = [
            "image/jpeg",
        ];

        const curFiles = document.querySelector("#fotoRicetta").files;
        if (curFiles.length != 0) {
            for (const file of curFiles) {
                const listItem = document.createElement("div");
                listItem.classList.add("specialitaCasa__form-preview-file");
                const para = document.createElement("p");
                if (fileTypes.includes(file.type) && (file.size < 5242880)) {
                    para.textContent = `${file.name}`;
                    const image = document.createElement("img");

                    Utils.getBase64(file).then((base64) => {
                        //image.src = URL.createObjectURL(file);
                        image.src = base64;
                        image.alt = image.title = file.name;
                    });

                    let delButton = document.createElement("button");
                    delButton.textContent = 'X';
                    delButton.classList.add('specialitaCasa__form-preview-delete');

                    listItem.appendChild(delButton);
                    listItem.appendChild(image);
                    listItem.appendChild(para);
                }

                document.querySelector(".specialitaCasa__form-preview").appendChild(listItem);

                this.fakeFile();
            }

            let collection = document.querySelectorAll('.specialitaCasa__form-preview-file');
            for (let i = 5; i < collection.length; i++) {
                collection[i].remove();
            }

            this.uploadCtaManager();
        }
    }

    fakeFile() {
        //Trick to upload the same last file deleted
        const myFile = new File(['Fake file'], 'myFile.txt', {
            type: 'image/jpeg',
            lastModified: new Date(),
        });

        // Now let's create a DataTransfer to get a FileList
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(myFile);

        document.querySelector('#fotoRicetta').files = dataTransfer.files;
    }

    deleteFile() {
        document.addEventListener('click', (e)=> {
            if(e.target.classList.contains('specialitaCasa__form-preview-delete')) {

                if (document.querySelectorAll(".specialitaCasa__form-preview-file img").length == 1) {
                    document.querySelector('#fotoRicetta').value = '';
                }

                e.target.parentNode.remove();

                this.uploadCtaManager();
            }
        });
    }

    uploadCtaManager() {
        let uploadCtaButton = document.querySelector('.specialitaCasa__form-upload-cta');
        let collection = document.querySelectorAll('.specialitaCasa__form-preview-file');

        if (collection.length >= 5) {
            uploadCtaButton.setAttribute('disabled', 'disabled');
        } else {
            uploadCtaButton.removeAttribute('disabled');
        }
    }

    submitForm() {
        if (this.$form.is(':invalid')) {
            return false;
        } else {
            //chiamata api
            $('#overlayer').show();
            this.specialitaCasa().then(() => {
                this.setCH();
                let div = document.createElement('div');
                div.classList.add('specialitaCasa__form-response-image');

                document.querySelector('.specialitaCasa__form-wrapper').prepend(div);
                document.querySelector('.specialitaCasa__form-intro').innerText = 'Grazie per aver partecipato!';
                document.querySelector('.specialitaCasa__form-description').innerHTML = `
                    <div class="specialitaCasa__form-response-title">Potresti essere selezionato come uno dei protagonisti del cooking show di Mulino Bianco!</div>
                    <div class="specialitaCasa__form-response-subtitle">Se verrai scelto, <b>ti contatteremo via e-mail entro il 11/04/2025</b> con tutti i dettagli.<br>Potrebbe essere richiesto un breve video di presentazione prima della conferma definitiva della partecipazione a “Specialità della casa”.<br><br><br>Mentre selezioniamo i partecipanti lasciati ispirare dalle nostre gustose ricette<br><br><a class="button" href="/ricette/pani-morbidi">Vai alle ricette</a></div>
                `;

                this.$form.remove();
                $('#overlayer').hide();
                $(window).scrollTop(0);

            }, (error) => {
                $('.specialitaCasa__form').append(`<div class="specialitaCasa__form-error">${error}</div>`);
                console.log(error);
                window.scrollTo(0, 1000);
            });
        }
    }

    setCH() {
        GigyaManager.addCH(this.key).then(() => {
            $('#overlayer').hide();
        }).catch((error) => {
            console.log(error);
            $('.specialitaCasa__form').append(`<div class="specialitaCasa__form-error">${error}</div>`);
            $('#overlayer').hide();
        });
    }

    specialitaCasa() {
        return new Promise((resolve, reject) => {
            let formData = {};

            document.querySelectorAll(".specialitaCasa__form-preview-file img").forEach(function(el, index) {
                formData[`file_${index}`] = el.src;
            });

            if (document.querySelector('#igProfile').value.trim() != '') {
                formData.profileig = document.querySelector('#igProfile').value;
            }

            formData.product = document.querySelector('input[name="prodotto"]:checked').value;

            HttpClient.doCall({
                method: 'POST',
                url: API_ENDPOINT + `/api/mulinobianco/1.0/web/landing/specialitacasa/item`,
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify(formData)
            }).then((data) => resolve(data.body), (error) => {
                $('#overlayer').hide();
                reject(error);
            });
        });
    }
}


export default SpecialitaCasaFormComponent;
